import {
  JobconfigBannerCornersOnlyIcon,
  JobconfigBannerEveryFeetIcon,
  JobconfigBannerHemmingIcon,
} from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadioProps } from 'components/RevxRadio';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const Banners = (props: ConfigSvcProps) => {
  const { jobOptionSvc } = props;

  const hideSvc = useHideSvc(props);

  const hideSvcContainer = useHideSvcContainer(props);

  const locationRadioProps = (
    labelArr: string[],
    disabled?: boolean
  ): RevxRadioProps => {
    return {
      disabled,
      outSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className: 'jobconfig-jobOption-content-outSideOption-default',
        style: {
          paddingBottom: 0,
        },
      },
      inSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className:
          'jobconfig-jobOption-content-inSideOption-default jobconfig-jobOption-content-inSideOption-banner',
        style: {
          marginRight: 31,
          paddingTop: '8px',
        },
      },
      options: [
        {
          value: 'Every 2 Feet',
          children: (
            <>
              <span>Every 2 Feet</span>
              <JobconfigBannerEveryFeetIcon />
            </>
          ),
        },
        {
          value: 'Corners Only',
          children: (
            <>
              <span>Corners Only</span>
              <JobconfigBannerCornersOnlyIcon />
            </>
          ),
        },
        {
          value: 'None',
          children: (
            <>
              <span>No</span>
              <span className="revx-icon">
                <svg></svg>
              </span>
            </>
          ),
        },
      ].filter((item) => labelArr.includes(item.value)),
    };
  };

  const attrRadioProps = (
    labelArr: string[],
    disabled?: boolean
  ): RevxRadioProps => {
    return {
      disabled,
      outSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className: 'jobconfig-jobOption-content-outSideOption-default',
        style: {
          paddingBottom: 0,
        },
      },
      inSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className:
          'jobconfig-jobOption-content-inSideOption-default jobconfig-jobOption-content-inSideOption-banner',
        style: {
          marginRight: 31,
        },
      },
      options: [
        {
          value: 'Yes',
          children: (
            <>
              <span>Yes</span>
              <JobconfigBannerHemmingIcon />
            </>
          ),
        },
        {
          value: 'No',
          children: (
            <>
              <span>No</span>
              <span className="revx-icon">
                <svg></svg>
              </span>
            </>
          ),
        },
      ].filter((item) => labelArr.includes(item.value)),
    };
  };

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <CommonJobSvcCotainer {...props}>
            {jobOptionSvc.revxId === 26 && (
              <>
                <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
                <CommonJobSvcOption
                  {...props}
                  customerRadioProps={locationRadioProps}
                  disabled={hideSvcContainer}
                />
              </>
            )}
            {jobOptionSvc.revxId === 27 && (
              <>
                <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
                <CommonJobSvcOption
                  {...props}
                  customerRadioProps={attrRadioProps}
                  disabled={hideSvcContainer}
                />
              </>
            )}
            <CommonQuantityPerBundle {...props} disabled={hideSvcContainer} />
            <CommonJobSvcInstructions {...props} disabled={hideSvcContainer} />
            <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
          </CommonJobSvcCotainer>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default Banners;
